import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import useLocales from "src/hooks/useLocales";
import { getCurrency } from "src/utils/currencies";
import * as Yup from "yup";

type SchemaProps = {
	shares?: number;
	amount?: number;
};

type Props = {
	maxShares: number;
	maxValue: number;
	defaultShares?: number | null;
	defaultAmount?: number | null;
	currency: string;
};

export const useCustomInputForm = ({
	maxShares,
	maxValue,
	defaultShares,
	defaultAmount,
	currency
}: Props) => {
	const { translate } = useLocales();

	const Schema = Yup.object().shape({
		shares: Yup.number()
			.typeError("La cantidad debe ser positivo")
			.positive("La cantidad debe ser positivo")
			.max(maxShares, translate("La cantidad debe ser menor a ") + maxShares.toFixed(4)),
		amount: Yup.number()
			.typeError("La cantidad debe ser positivo")
			.positive("La cantidad debe ser positivo")
			.max(
				maxValue,
				translate(`La cantidad debe ser menor a ${maxValue.toFixed(2)} ${getCurrency(currency)}`)
			)
	});

	const methods = useForm<SchemaProps>({
		resolver: yupResolver(Schema),
		defaultValues: { shares: defaultShares ?? undefined, amount: defaultAmount ?? undefined },
		mode: "onChange",
		reValidateMode: "onBlur"
	});

	return {
		methods
	};
};
